import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Mail } from 'lucide-react';

const faqs = [
  {
    question: '교류전은 어떻게 신청하나요?',
    answer: '교류전 매칭 탭에서 상대 팀 카드를 누르면 팀 프로필을 볼 수 있어요. 하단의 \'매칭 신청하기\' 버튼을 눌러 신청을 보내면 됩니다. 신청 결과는 내 매칭 탭에서 확인할 수 있어요.',
  },
  {
    question: '매칭이 성사된 후에는 어떻게 하나요?',
    answer: '내 매칭 탭에서 받은 신청을 수락하면 자동으로 채팅방이 생성됩니다. 채팅방에서 일정·장소를 조율하고, 일정 등록 버튼으로 경기 정보를 고정할 수 있어요. 채팅방은 경기일 기준 5일 후 자동으로 사라집니다.',
  },
  {
    question: '팀은 어떻게 등록하나요?',
    answer: '내 정보 탭에서 \'팀 등록하기\'를 누르세요. 종목, 레벨, 인원 구성 등 기본 정보를 입력하면 바로 등록돼요. 등록된 팀은 상대 팀의 교류전 목록에 노출됩니다.',
  },
];

export default function Support({ onBack }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* 상단 헤더 */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" style={{ paddingTop: "env(safe-area-inset-top)" }}>
        <div className="max-w-lg mx-auto px-4 py-4 flex items-center gap-3">
          <button
            onClick={onBack}
            className="text-gray-500 text-sm flex items-center gap-1"
          >
            ‹ 뒤로
          </button>
          <h1 className="text-base font-semibold text-gray-800 flex-1 text-center pr-10">
            고객지원
          </h1>
        </div>
      </div>

      <div className="max-w-lg mx-auto w-full px-4 py-6 flex flex-col gap-6">
        {/* 이메일 문의 카드 */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-start gap-4">
          <div className="bg-red-50 rounded-full p-3 flex-shrink-0">
            <Mail className="w-5 h-5 text-red-500" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-800 mb-1">이메일 문의</p>
            <a
              href="mailto:yongjunxx@gmail.com"
              className="text-red-500 font-medium text-sm break-all"
            >
              yongjunxx@gmail.com
            </a>
            <p className="text-xs text-gray-400 mt-1">보통 1-2 영업일 내에 답변드려요</p>
          </div>
        </div>

        {/* FAQ */}
        <div>
          <h2 className="text-sm font-semibold text-gray-500 mb-3 px-1">자주 묻는 질문</h2>
          <div className="flex flex-col gap-2">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-gray-800 leading-snug pr-4">
                    {faq.question}
                  </span>
                  {openIndex === i
                    ? <ChevronUp className="w-4 h-4 text-gray-400 flex-shrink-0" />
                    : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />}
                </button>
                {openIndex === i && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
